import { useEffect, useState } from 'react';

const navLinks = [
  { label: '热门连载', href: '#featured' },
  { label: '题材分类', href: '#categories' },
  { label: '独家抢先看', href: '#exclusive' },
  { label: '本周更新榜', href: '#rank' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-primary-600">喵趣漫画网</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#exclusive"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:inline-flex"
          >
            <i className="ri-flashlight-fill text-base"></i>
            抢先看新作
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-primary-50 md:hidden"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}